import { render, staticRenderFns } from "./RegisteringSection.vue?vue&type=template&id=4410938f&scoped=true"
import script from "./RegisteringSection.vue?vue&type=script&lang=js"
export * from "./RegisteringSection.vue?vue&type=script&lang=js"
import style0 from "./RegisteringSection.vue?vue&type=style&index=0&id=4410938f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410938f",
  null
  
)

export default component.exports